<style lang="stylus">
    .ShapeData-mask
        modal-mask()
        .ShapeData-modal
            width 500px
            overflow auto
            color $modal-content-textcolor
        .dialog-container-component
            .dialog-title
                .item-icon
                    left 14px
                .title-text
                    left 44px
            .ShapeData-container
                .ivu-input-wrapper
                    input
                        color $modal-content-textcolor
                .ShapeData-leftbox
                    float left
                    width 50%
                    overflow auto
                    .leftbox-line
                        display flex
                        justify-content space-between
                        align-items center
                        flex-wrap wrap
                        margin-bottom 10px
                        overflow auto
                        .leftbox-Dropdown
                            width 60%
                            .leftbox-showbox
                                position relative
                                width 100%
                                border 1px solid #dcdee2
                                font-size 12px
                                padding-left 10px
                                height 24px
                                line-height 24px
                                overflow hidden
                                i
                                    position absolute
                                    right 5px
                                    top 6px
                            .ivu-select-dropdown
                                width 50%
                        .leftbox-title
                            width 40%
                        .leftbox-colorLine
                            display flex
                            justify-content space-between
                            width 60%
                            .colorLine-colorbtn
                                colorbtn()
                                width 32px
                                height 24px
                        .leftbox-timer
                            position absolute
                            left 260px
                            width 138px
                        .ivu-select-disabled
                            .ivu-select-selected-value
                                color #ccc

                .ShapeData-rightbox
                    position relative
                    float left
                    width 50%
                    padding-left 10px
                    .rightbox-line
                        display flex
                        justify-content space-between
                        align-items center
                        margin-bottom 10px
                        overflow auto
                        &.disabled
                            .rightbox-title
                                color var(--text-color-tertiary)
                            .ivu-select
                                .ivu-select-placeholder
                                    color: var(--color-text-quaternary, #515a6e)
                            .ivu-select-selection
                                background-color var(--bg-color-ivu-component-disabled);
                                color: var(--color-text-quaternary, #515a6e)
                        .rightbox-checkbox
                            padding-bottom 2px
                            margin-left auto
                            &:not(.ivu-checkbox-checked)
                                .ivu-checkbox-inner
                                    background-color var(--bg-color-tertiary)
                        .rightbox-title
                            width 40%
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                    .ShapeData-rightbox-mask
                        position absolute
                        left 0
                        top 0
                        bottom 0
                        right 0
                        background-color var(--bg-color-org-shape-data-mask)
                        cursor not-allowed
                        z-index 1
                .ShapeData-bottombox
                    clear left
                    position relative
                    width 100%
                    height 175px
                    .bottombox-title
                        margin-bottom 10px
                    .databox-toolbox
                        position absolute
                        top 0
                        right 0
                        .ban-btn
                            cursor not-allowed
                            opacity .2
                        >div
                            float left
                            width 22px
                            height 22px
                            padding 2px
                            border-radius 3px
                            user-select none
                            cursor pointer
                            .item-icon
                                width 18px
                                height 18px
                                color var(--svg-color-gray-42-secondary)
                            &:not(:first-child)
                                margin-left 15px
                            &:not(.ban-btn):hover
                                background-color $main-hovercolor
                    .ShapeData-databox
                        width 100%
                        max-height 400px
                        border 1px solid $box-bordercolor
                        border-radius 3px
                        .databox-title
                            height 25px
                            width 100%
                            border-bottom 1px solid $box-bordercolor
                            background-color var(--bg-color-tertiary)
                            p
                                float left
                                width 20%
                                text-align center
                                line-height 25px
                                color $modal-content-textcolor
                                font-size 12px
                                &:not(:last-child)
                                    border-right 1px solid $box-bordercolor
                        .databox-content
                            width 100%
                            max-height 120px
                            list-style none
                            overflow-y auto
                            li
                                overflow auto
                                user-select none
                                cursor pointer
                                p
                                    float left
                                    width 20%
                                    height 25px
                                    text-align center
                                    line-height 25px
                                    color $modal-content-textcolor
                                    font-size 12px
                                    overflow hidden
                                    text-overflow ellipsis
                                    white-space nowrap
                                &:not(.active-item):hover
                                    background-color $main-hovercolor
                            .active-item
                                background-color $main-selectcolor

                .ShapeData-preview
                    display flex
                    width 100%
                    height 18px
                    overflow auto
                    margin 10px 0
                    .previewbox-title
                        width 20%
                    .previewbox-showText
                        width 80%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .ShapeData-decriptionbox
                    width 100%
                    overflow auto
                    margin-bottom 10px
                    .decriptionbox-title
                        margin-bottom 10px
                .ShapeData-line
                    margin-bottom 10px
                    height 30px
                    line-height 30px
                    span
                        vertical-align middle
                    .ShapeData-input
                        float right
</style>

<template>
    <div class="ShapeData-mask">
        <Dialog
            class="ShapeData-modal"
            :title="showShapeData ? $t('title') : $t('domaintitle')"
            :isShow="true"
            :extra="true"
            :icon="EDCONFIG.IS_SDK ? '' : 'newEdrawIcon'"
            @close="closeModal"
        >
            <div class="ShapeData-container">
                <div class="ShapeData-leftbox">
                    <div class="leftbox-line">
                        <p class="leftbox-title">{{ $t("name") }}:</p>
                        <Input
                            v-model="nameInput"
                            size="small"
                            style="width: 60%"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeItem('name');
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                            :maxlength="100"
                        />
                    </div>
                    <div class="leftbox-line">
                        <p class="leftbox-title">{{ $t("type") }}:</p>
                        <i-select v-model="clickType" style="width: 60%" size="small" @on-change="changeItem('type')" :disabled="disabled">
                            <i-option v-if="item.value != ''" :value="item.value" v-for="item in typeList" :key="item.id">
                                {{ $t(item.text) }}
                            </i-option>
                        </i-select>
                    </div>
                    <div class="leftbox-line">
                        <p class="leftbox-title">{{ $t("format") }}:</p>

                        <i-select
                            v-if="clickType == 'string'"
                            v-model="clickString"
                            style="width: 60%"
                            size="small"
                            @on-change="changeItem('format')"
                            :disabled="disabled"
                        >
                            <i-option :value="item.id" v-for="item in stringList" :key="item.id">{{ $t(item.text) }}</i-option>
                        </i-select>

                        <i-select
                            v-if="clickType == 'number'"
                            v-model="clickNumber"
                            style="width: 60%"
                            size="small"
                            @on-change="changeOption('unit')"
                            :disabled="disabled"
                        >
                            <i-option :value="0" :label="getNumberOption()"></i-option>
                            <i-option v-if="clickUnit == 1" :value="1" :label="getNumberOption() + '&quot;' + pageUnit + '&quot;'"></i-option>
                            <i-option
                                v-if="clickUnit > 1"
                                :value="1"
                                :label="getNumberOption() + '&quot;' + unitList[lang][clickUnit].short + '&quot;'"
                            ></i-option>
                            <i-option
                                v-if="clickUnit > 1"
                                :value="2"
                                :label="getNumberOption() + '&quot;' + unitList[lang][clickUnit].full + '&quot;'"
                            ></i-option>
                        </i-select>

                        <i-select
                            v-if="clickType == 'dateTime'"
                            v-model="clickDateTime"
                            style="width: 60%"
                            size="small"
                            @on-change="changeItem('format')"
                            :disabled="disabled"
                        >
                            <i-option :value="item.id" v-for="item in dateList" :key="item.id">{{ $t(item.text) }}</i-option>
                        </i-select>

                        <i-select
                            v-if="clickType == 'duration'"
                            v-model="clickDuration"
                            style="width: 60%"
                            size="small"
                            @on-change="changeItem('format')"
                            :disabled="disabled"
                        >
                            <i-option :value="item.id" v-for="item in durationList" :key="item.id">{{ $t(item.text) }}</i-option>
                        </i-select>

                        <i-select
                            v-if="clickType == 'currency'"
                            v-model="clickCurrency"
                            style="width: 60%"
                            size="small"
                            @on-change="changeItem('format')"
                            :disabled="disabled"
                        >
                            <i-option v-if="clickCurrencyUnit == -1" :value="-1" :label="getNumberOption()"></i-option>
                            <i-option v-else :value="item.id" v-for="item in getCurrencyLeft()" :key="item.id" :label="item.text"></i-option>
                        </i-select>

                        <Input v-if="['boolean', 'color'].includes(clickType)" disabled type="text" style="width: 60%" size="small" />

                        <Input
                            v-if="clickType == 'list'"
                            v-model="clickList"
                            size="small"
                            style="width: 60%"
                            placeholder="e.g  red;blue;green"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeItem('format');
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        />

                        <Input
                            v-if="clickType == 'percentage'"
                            v-model="percentInput"
                            readonly
                            type="text"
                            style="width: 60%"
                            size="small"
                            :disabled="disabled"
                        />

                        <i-select
                            v-if="clickType == 'scientific'"
                            v-model="clickScientific"
                            style="width: 60%"
                            size="small"
                            @on-change="changeItem('format')"
                            :disabled="disabled"
                        >
                            <i-option :value="0" :label="decimalInput + 'e+0'"></i-option>
                            <i-option :value="1" :label="decimalInput + 'e+00'"></i-option>
                        </i-select>

                        <Input v-if="!clickType" type="text" style="width: 60%" size="small" readonly />
                    </div>
                    <div class="leftbox-line">
                        <p class="leftbox-title">{{ $t("value") }}:</p>

                        <Input
                            v-if="['string', 'duration', 'list'].includes(clickType)"
                            v-model="valueInput"
                            size="small"
                            style="width: 60%"
                            :disabled="disabled"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeItem('value');
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        />

                        <DatePicker
                            v-if="clickType == 'dateTime'"
                            v-model="dateInput"
                            :clearable="false"
                            type="date"
                            size="small"
                            style="width: 60%; display: block"
                            @on-change="setDate"
                        ></DatePicker>
                        <TimePicker
                            class="leftbox-timer"
                            v-if="clickType == 'dateTime'"
                            v-model="timeInput"
                            type="time"
                            size="small"
                            @on-change="setTime"
                        ></TimePicker>

                        <i-select v-if="clickType == 'boolean'" v-model="valueInput" style="width: 60%" size="small" @on-change="changeItem('value')">
                            <i-option :value="'true'" :label="'true'"></i-option>
                            <i-option :value="'false'" :label="'false'"></i-option>
                        </i-select>

                        <div class="leftbox-colorLine" v-if="clickType == 'color'">
                            <Input
                                v-model="colorInput"
                                size="small"
                                style="width: 60%"
                                @on-focus="editLocker('focus', 'inputLocker')"
                                @on-blur="
                                    editLocker('blur', 'inputLocker', () => {
                                        changeItem('value');
                                    })
                                "
                                @keyup.enter.native="iviewInputBlur($event)"
                            />
                            <div class="colorLine-colorbtn" @click="showColor($event)">
                                <div :style="{ backgroundColor: colorValue }"></div>
                            </div>
                        </div>

                        <InputNumber
                            v-if="['number', 'currency', 'percentage', 'scientific'].includes(clickType)"
                            v-model="valueNumberInput"
                            size="small"
                            style="width: 60%"
                            :disabled="disabled"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeItem('value');
                                })
                            "
                            @on-change="
                                editLocker('blur', 'inputLocker', () => {
                                    changeItem('value');
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                            :max="9007199254740992"
                        />

                        <Input v-if="!clickType" type="text" style="width: 60%" size="small" readonly />
                    </div>
                </div>
                <div class="ShapeData-rightbox">
                    <div class="rightbox-line" :class="{ disabled: !['number', 'currency'].includes(clickType) }">
                        <p class="rightbox-title" :title="$t('decimal')">{{ $t("decimal") }}:</p>
                        <i-select v-model="clickDecimal" placement="bottom-end" style="width: 60%" size="small" @on-change="changeOption('decimal')">
                            <i-option :value="index" v-for="(item, index) in 7" :key="index">{{ index }}</i-option>
                        </i-select>
                    </div>
                    <div
                        class="rightbox-line"
                        :class="{ disabled: !['number', 'currency'].includes(clickType) }"
                        style="height: 22px; margin-bottom: 11px"
                    >
                        <Checkbox class="rightbox-checkbox" v-model="clickCheckbox" @on-change="changeOption('checkbox')">
                            {{ $t("separator") }}
                        </Checkbox>
                    </div>
                    <div class="rightbox-line" :class="{ disabled: !['number', 'currency'].includes(clickType) }">
                        <p class="rightbox-title" :title="$t('unit-currency')">{{ $t("unit-currency") }}:</p>
                        <i-select
                            v-show="clickType == 'number'"
                            placement="bottom-end"
                            v-model="clickUnit"
                            style="width: 60%"
                            size="small"
                            @on-change="changeOption('unit')"
                        >
                            <i-option :value="item.id" v-for="item in unitList[lang]" :key="item.id">{{ $t(item.text) }}</i-option>
                        </i-select>

                        <i-select
                            v-show="clickType == 'currency'"
                            placement="bottom-end"
                            v-model="clickCurrencyUnit"
                            style="width: 60%"
                            size="small"
                            @on-change="changeOption('unit')"
                        >
                            <i-option :value="-1">None</i-option>
                            <i-option :value="index" v-for="(item, index) in curListText[lang]" :key="index">{{ getCurrencyRight(index) }}</i-option>
                        </i-select>

                        <i-select v-if="!['number', 'currency'].includes(clickType)" style="width: 60%" size="small">
                            <i-option :value="123"></i-option>
                        </i-select>
                    </div>
                    <div
                        class="ShapeData-rightbox-mask"
                        v-if="!['number', 'currency'].includes(clickType)"
                        :style="{ top: clickType == 'percentage' || clickType == 'scientific' ? '30px' : '0' }"
                    ></div>
                </div>
                <div class="ShapeData-preview">
                    <p class="previewbox-title">{{ $t("preview") }}:</p>
                    <p class="previewbox-showText" v-text="previewFormat"></p>
                </div>
                <div class="ShapeData-decriptionbox">
                    <p class="decriptionbox-title">{{ $t("description") }}:</p>
                    <Input
                        type="textarea"
                        v-model="descriptionInput"
                        style="width: 100%"
                        size="small"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeItem('description');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    />
                </div>

                <div class="ShapeData-bottombox">
                    <p class="bottombox-title">{{ $t("data") }}:</p>
                    <div class="databox-toolbox">
                        <div @click="0 != clickIndex && moveItem('up')" :class="{ 'ban-btn': 0 == clickIndex }">
                            <iconSymbol class="item-icon" name="property-up"></iconSymbol>
                        </div>
                        <div @click="tempList.length - 1 != clickIndex && moveItem('down')" :class="{ 'ban-btn': tempList.length - 1 == clickIndex }">
                            <iconSymbol class="item-icon" name="property-down"></iconSymbol>
                        </div>
                        <div @click="addItem()">
                            <iconSymbol class="item-icon" name="property-addAttr"></iconSymbol>
                        </div>
                        <div @click="delItem()">
                            <iconSymbol class="item-icon" name="property-delAttr"></iconSymbol>
                        </div>
                    </div>
                    <div class="ShapeData-databox">
                        <div class="databox-title" :style="{ width: tableWidth }">
                            <p>{{ $t("name") }}</p>
                            <p>{{ $t("type") }}</p>
                            <p>{{ $t("format") }}</p>
                            <p>{{ $t("value") }}</p>
                            <p>{{ $t("description") }}</p>
                        </div>
                        <ul class="databox-content" ref="tableSrcoll">
                            <li v-for="item in tempList" :key="item.id" :class="{ 'active-item': item.id == clickID }" @click="selectItem(item.id)">
                                <p>{{ item.name }}</p>
                                <p>{{ $t("typeList." + typeList[item.type]["value"]) }}</p>
                                <p>{{ item.format }}</p>
                                <p>{{ item.value }}</p>
                                <p>{{ item.description }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    declare var EDProperty: any;
    declare var EDFormat: any;
    @Component({
        components: {
            Dialog,
        },
    })
    export default class ShapeData extends Vue {
        @Inject()
        ["iviewInputBlur"];

        previewFormat: string = "";
        tableWidth: string = "";
        inputLocker: boolean = false;
        disabled: boolean = false;
        clickID: number = 0; // 选中数据id
        clickIndex: number = 0; // 选中数据索引
        clickType: string = ""; // 当前选择类型
        clickString: number = 0; // 字符串格式
        clickNumber: number = 0; // 数字格式
        clickDateTime: number = 0; // 日期格式
        clickDuration: number = 0; // 持续时间格式
        clickCurrency: number = -1; // 货币格式
        clickList: string = ""; // 列表格式
        percentInput: string = ""; // 百分号格式

        clickCheckbox: boolean = false; // 是否使用千分符
        clickUnit: number = 0; // 选择的单位索引
        clickCurrencyUnit: number = -1; // 选择的货币索引
        clickDecimal: number = 0; // 选择小数位索引
        clickScientific: number = 0; // 选择科学计数索引

        decimalInput: string = "0";
        nameInput: string = "";
        numberInput: string = "0";
        dateInput: string = "";
        timeInput: string = "00:00:00";
        colorInput: string = ""; // 颜色值
        formatInput: string = ""; // 暂存格式字符串
        valueInput: string = ""; // 暂存值字符串
        valueNumberInput: number = 0; // 数字类型的值
        descriptionInput: string = "";
        typeList: Array<object> = [
            {
                id: 0,
                text: "typeList.string",
                value: "string",
            },
            {
                id: 1,
                text: "typeList.number",
                value: "number",
            },
            {
                id: 2,
                text: "typeList.dateTime",
                value: "dateTime",
            },
            {
                id: 3,
                text: "typeList.duration",
                value: "duration",
            },
            {
                id: 4,
                text: "typeList.currency",
                value: "currency",
            },
            {
                id: 5,
                text: "typeList.boolean",
                value: "boolean",
            },
            {
                id: 6,
                text: "typeList.list",
                value: "list",
            },
            {
                id: 7,
                text: "",
                value: "",
            },
            {
                id: 8,
                text: "typeList.color",
                value: "color",
            },
            {
                id: 9,
                text: "typeList.percentage",
                value: "percentage",
            },
            {
                id: 10,
                text: "typeList.scientific",
                value: "scientific",
            },
        ];
        stringList: Array<object> = [
            {
                id: 0,
                text: "stringList.normal",
                value: "@",
            },
            {
                id: 1,
                text: "stringList.uppercase",
                value: "@+",
            },
            {
                id: 2,
                text: "stringList.lowercase",
                value: "@-",
            },
        ];
        unitList: object = {
            zh: [
                {
                    id: 0,
                    text: "无",
                },
                {
                    id: 1,
                    text: "页面单位",
                },
                {
                    id: 2,
                    text: "km(千米)",
                    short: "km",
                    full: "千米",
                },
                {
                    id: 3,
                    text: "hm(百米)",
                    short: "he",
                    full: "百米",
                },
                {
                    id: 4,
                    text: "dam(十米)",
                    short: "dam",
                    full: "十米",
                },
                {
                    id: 5,
                    text: "m(米)",
                    short: "m",
                    full: "米",
                },
                {
                    id: 6,
                    text: "dm(分米)",
                    short: "dm",
                    full: "分米",
                },
                {
                    id: 7,
                    text: "cm(厘米)",
                    short: "cm",
                    full: "厘米",
                },
                {
                    id: 8,
                    text: "mm(毫米)",
                    short: "mm",
                    full: "毫米",
                },
                {
                    id: 9,
                    text: "dmm(丝米)",
                    short: "dmm",
                    full: "丝米",
                },
                {
                    id: 10,
                    text: "cmm(忽米)",
                    short: "cmm",
                    full: "忽米",
                },
                {
                    id: 11,
                    text: "um(微米)",
                    short: "um",
                    full: "微米",
                },
                {
                    id: 12,
                    text: "n.m(海里)",
                    short: "n.m",
                    full: "海里",
                },
                {
                    id: 13,
                    text: "mi(英里)",
                    short: "mi",
                    full: "英里",
                },
                {
                    id: 14,
                    text: "yd(码)",
                    short: "yd",
                    full: "码",
                },
                {
                    id: 15,
                    text: "ft(英尺)",
                    short: "ft",
                    full: "英尺",
                },
                {
                    id: 16,
                    text: "in(英寸)",
                    short: "in",
                    full: "英寸",
                },
                {
                    id: 17,
                    text: "sq.km(平方公里)",
                    short: "sq.km",
                    full: "平方公里",
                },
                {
                    id: 18,
                    text: "ha(公顷)",
                    short: "ha",
                    full: "公顷",
                },
                {
                    id: 19,
                    text: "a(公亩)",
                    short: "a",
                    full: "公亩",
                },
                {
                    id: 20,
                    text: "sq.m(平方米)",
                    short: "sq.m",
                    full: "平方米",
                },
                {
                    id: 21,
                    text: "sq.cm(平方厘米)",
                    short: "sq.cm",
                    full: "平方厘米",
                },
                {
                    id: 22,
                    text: "sq.mi(平方英里)",
                    short: "sq.mi",
                    full: "平方英里",
                },
                {
                    id: 23,
                    text: "ac(英亩)",
                    short: "ac",
                    full: "英亩",
                },
                {
                    id: 24,
                    text: "sq.yd(平方码)",
                    short: "sq.yd",
                    full: "平方码",
                },
                {
                    id: 25,
                    text: "sq.ft(平方英尺)",
                    short: "sq.ft",
                    full: "平方英尺",
                },
                {
                    id: 26,
                    text: "sq.in(平方英寸)",
                    short: "sq.in",
                    full: "平方英寸",
                },
                {
                    id: 27,
                    text: "t(吨)",
                    short: "t",
                    full: "吨",
                },
                {
                    id: 28,
                    text: "q(公担)",
                    short: "q",
                    full: "公担",
                },
                {
                    id: 29,
                    text: "kg(公斤)",
                    short: "kg",
                    full: "公斤",
                },
                {
                    id: 30,
                    text: "hg(百克)",
                    short: "hg",
                    full: "百克",
                },
                {
                    id: 31,
                    text: "dag(十克)",
                    short: "dag",
                    full: "十克",
                },
                {
                    id: 32,
                    text: "g(克)",
                    short: "g",
                    full: "克",
                },
                {
                    id: 33,
                    text: "dg(分克)",
                    short: "dg",
                    full: "分克",
                },
                {
                    id: 34,
                    text: "cg(厘克)",
                    short: "cg",
                    full: "厘克",
                },
                {
                    id: 35,
                    text: "mg(毫克)",
                    short: "mg",
                    full: "毫克",
                },
                {
                    id: 36,
                    text: "ug(微克)",
                    short: "ug",
                    full: "微克",
                },
                {
                    id: 37,
                    text: "l.t(长吨)",
                    short: "l.t",
                    full: "长吨",
                },
                {
                    id: 38,
                    text: "s.t(短吨)",
                    short: "s.t",
                    full: "短吨",
                },
                {
                    id: 39,
                    text: "cwt(英担)",
                    short: "cwt",
                    full: "英担",
                },
                {
                    id: 40,
                    text: "stone(英石)",
                    short: "stone",
                    full: "英石",
                },
                {
                    id: 41,
                    text: "lb(磅)",
                    short: "lb",
                    full: "磅",
                },
                {
                    id: 42,
                    text: "oz(盎司)",
                    short: "oz",
                    full: "盎司",
                },
                {
                    id: 43,
                    text: "dr(打兰)",
                    short: "dr",
                    full: "打兰",
                },
                {
                    id: 44,
                    text: "gr(格令)",
                    short: "gr",
                    full: "格令",
                },
                {
                    id: 45,
                    text: "kl(千升)",
                    short: "kl",
                    full: "千升",
                },
                {
                    id: 46,
                    text: "hl(百升)",
                    short: "hl",
                    full: "百升",
                },
                {
                    id: 47,
                    text: "dal(十升)",
                    short: "dal",
                    full: "十升",
                },
                {
                    id: 48,
                    text: "l(升)",
                    short: "l",
                    full: "升",
                },
                {
                    id: 49,
                    text: "dl(分升)",
                    short: "dl",
                    full: "分升",
                },
                {
                    id: 50,
                    text: "cl(厘升)",
                    short: "cl",
                    full: "厘升",
                },
                {
                    id: 51,
                    text: "ml(毫升)",
                    short: "ml",
                    full: "毫升",
                },
                {
                    id: 52,
                    text: "ul(微升)",
                    short: "ul",
                    full: "微升",
                },
                {
                    id: 53,
                    text: "bsh(蒲式耳)",
                    short: "bsh",
                    full: "蒲式耳",
                },
                {
                    id: 54,
                    text: "pk(配克)",
                    short: "pk",
                    full: "配克",
                },
                {
                    id: 55,
                    text: "gal(加仑)",
                    short: "gal",
                    full: "加仑",
                },
                {
                    id: 56,
                    text: "qt(夸脱)",
                    short: "qt",
                    full: "夸脱",
                },
                {
                    id: 57,
                    text: "p(品脱)",
                    short: "p",
                    full: "品脱",
                },
                {
                    id: 58,
                    text: "A(安培)",
                    short: "A",
                    full: "安培",
                },
                {
                    id: 59,
                    text: "K(开)",
                    short: "K",
                    full: "开",
                },
                {
                    id: 60,
                    text: "mol(摩尔)",
                    short: "mol",
                    full: "摩尔",
                },
                {
                    id: 61,
                    text: "cd(坎德拉)",
                    short: "cd",
                    full: "坎德拉",
                },
                {
                    id: 62,
                    text: "s(秒)",
                    short: "s",
                    full: "秒",
                },
                {
                    id: 63,
                    text: "Hz(赫兹)",
                    short: "Hz",
                    full: "赫兹",
                },
                {
                    id: 64,
                    text: "Pa(帕斯卡)",
                    short: "Pa",
                    full: "帕斯卡",
                },
                {
                    id: 65,
                    text: "N(牛顿)",
                    short: "N",
                    full: "牛顿",
                },
                {
                    id: 66,
                    text: "J(焦耳)",
                    short: "J",
                    full: "焦耳",
                },
                {
                    id: 67,
                    text: "W(瓦特)",
                    short: "W",
                    full: "瓦特",
                },
                {
                    id: 68,
                    text: "C(库仑)",
                    short: "C",
                    full: "库仑",
                },
                {
                    id: 69,
                    text: "V(伏特)",
                    short: "V",
                    full: "伏特",
                },
                {
                    id: 70,
                    text: "Ω(欧姆)",
                    short: "Ω",
                    full: "欧姆",
                },
                {
                    id: 71,
                    text: "F(法拉)",
                    short: "F",
                    full: "法拉",
                },
                {
                    id: 72,
                    text: "H(亨利)",
                    short: "H",
                    full: "亨利",
                },
                {
                    id: 73,
                    text: "°C(摄氏度)",
                    short: "°C",
                    full: "摄氏度",
                },
                {
                    id: 74,
                    text: "rad(弧度)",
                    short: "rad",
                    full: "弧度",
                },
                {
                    id: 75,
                    text: "sr(球面度)",
                    short: "sr",
                    full: "球面度",
                },
            ],
            en: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
            de: [
                {
                    id: 0,
                    text: "Nichts",
                },
                {
                    id: 1,
                    text: "Seinten-Einheit",
                },
                {
                    id: 2,
                    text: "km(Kilometer)",
                    short: "km",
                    full: "Kilometer",
                },
                {
                    id: 3,
                    text: "hm(Hektometer)",
                    short: "hm",
                    full: "Hektometer",
                },
                {
                    id: 4,
                    text: "dam(Dekameter)",
                    short: "dam",
                    full: "Dekameter",
                },
                {
                    id: 5,
                    text: "m(Meter)",
                    short: "m",
                    full: "Meter",
                },
                {
                    id: 6,
                    text: "dm(Dezimeter)",
                    short: "dm",
                    full: "Dezimeter",
                },
                {
                    id: 7,
                    text: "cm(Zentimeter)",
                    short: "cm",
                    full: "Zentimeter",
                },
                {
                    id: 8,
                    text: "mm(Millimeter)",
                    short: "mm",
                    full: "Millimeter",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "μm(Mikrometer)",
                    short: "μm",
                    full: "Mikrometer",
                },
                {
                    id: 12,
                    text: "n.m(Nanometer)",
                    short: "n.m",
                    full: "Nanometer",
                },
                {
                    id: 13,
                    text: "mi(Meilen)",
                    short: "mi",
                    full: "Meilen",
                },
                {
                    id: 14,
                    text: "yd(Yard)",
                    short: "yd",
                    full: "Yard",
                },
                {
                    id: 15,
                    text: "ft(Fuß)",
                    short: "ft",
                    full: "Fuß",
                },
                {
                    id: 16,
                    text: "in(Zoll)",
                    short: "in",
                    full: "Zoll",
                },
                {
                    id: 17,
                    text: "mm²(Quadratkilometer)",
                    short: "mm²",
                    full: "Quadratkilometer",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(Ar)",
                    short: "a",
                    full: "Ar",
                },
                {
                    id: 20,
                    text: "m²(Quadratmeter)",
                    short: "m²",
                    full: "Quadratmeter",
                },
                {
                    id: 21,
                    text: "cm²(Quadratzentimeter)",
                    short: "cm²",
                    full: "Quadratzentimeter",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(Acre)",
                    short: "ac",
                    full: "Acre",
                },
                {
                    id: 24,
                    text: "sq.yd(Quadratyard)",
                    short: "sq.yd",
                    full: "Quadratyard",
                },
                {
                    id: 25,
                    text: "sq.ft(Quadratfuß)",
                    short: "sq.ft",
                    full: "Quadratfuß",
                },
                {
                    id: 26,
                    text: "sq.in(Quadratzoll)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(Tonne)",
                    short: "t",
                    full: "Tonne",
                },
                {
                    id: 28,
                    text: "Ztr.(Zentner)",
                    short: "Ztr.",
                    full: "Zentner",
                },
                {
                    id: 29,
                    text: "kg(Kilogram)",
                    short: "kg",
                    full: "Kilogram",
                },
                {
                    id: 30,
                    text: "hg(Hektogramm)",
                    short: "hg",
                    full: "Hektogramm",
                },
                {
                    id: 31,
                    text: "dag(Dekagramm)",
                    short: "dag",
                    full: "Dekagramm",
                },
                {
                    id: 32,
                    text: "g(Gramm)",
                    short: "g",
                    full: "Gramm",
                },
                {
                    id: 33,
                    text: "dg(Dezigramm)",
                    short: "dg",
                    full: "Dezigramm",
                },
                {
                    id: 34,
                    text: "zg(Zentigramm)",
                    short: "zg",
                    full: "Zentigramm",
                },
                {
                    id: 35,
                    text: "mg(Milligramm)",
                    short: "mg",
                    full: "Milligramm",
                },
                {
                    id: 36,
                    text: "ug(Mikrogramm)",
                    short: "ug",
                    full: "Mikrogramm",
                },
                {
                    id: 37,
                    text: "tn. l.(Lange Tonne)",
                    short: "tn. l.",
                    full: "Lange Tonne",
                },
                {
                    id: 38,
                    text: "tn. sh.(Kurze Tonne;)",
                    short: "tn. sh.",
                    full: "Kurze Tonne",
                },
                {
                    id: 39,
                    text: "cwt(Hundredweight)",
                    short: "cwt",
                    full: "Hundredweight",
                },
                {
                    id: 40,
                    text: "st(Stone)",
                    short: "st",
                    full: "Stone",
                },
                {
                    id: 41,
                    text: "lb(Pfund)",
                    short: "lb",
                    full: "Pfund",
                },
                {
                    id: 42,
                    text: "oz(Unze)",
                    short: "oz",
                    full: "Unze",
                },
                {
                    id: 43,
                    text: "dr(Dram)",
                    short: "dr",
                    full: "Dram",
                },
                {
                    id: 44,
                    text: "gr(Gran)",
                    short: "gr",
                    full: "Gran",
                },
                {
                    id: 45,
                    text: "kl(Kiloliter)",
                    short: "kl",
                    full: "Kiloliter",
                },
                {
                    id: 46,
                    text: "hl(Hektoliter)",
                    short: "hl",
                    full: "Hektoliter",
                },
                {
                    id: 47,
                    text: "dal(Dekaliter)",
                    short: "dal",
                    full: "Dekaliter",
                },
                {
                    id: 48,
                    text: "l(Liter)",
                    short: "l",
                    full: "Liter",
                },
                {
                    id: 49,
                    text: "dl(Deziliter)",
                    short: "dl",
                    full: "Deziliter",
                },
                {
                    id: 50,
                    text: "zl(Zentiliter)",
                    short: "zl",
                    full: "Zentiliter",
                },
                {
                    id: 51,
                    text: "ml(Milliliter)",
                    short: "ml",
                    full: "Milliliter",
                },
                {
                    id: 52,
                    text: "μl(Mikroliter)",
                    short: "μl",
                    full: "Mikroliter",
                },
                {
                    id: 53,
                    text: "bsh(Bushel)",
                    short: "bsh",
                    full: "Bushel ",
                },
                {
                    id: 54,
                    text: "pk(Peck)",
                    short: "pk",
                    full: "Peck",
                },
                {
                    id: 55,
                    text: "gal(Gallone)",
                    short: "gal",
                    full: "Gallone",
                },
                {
                    id: 56,
                    text: "qt(Quart)",
                    short: "qt",
                    full: "Quart",
                },
                {
                    id: 57,
                    text: "pt(Pinte)",
                    short: "pt",
                    full: "Pinte",
                },
                {
                    id: 58,
                    text: "A(Ampere)",
                    short: "A",
                    full: "Ampere",
                },
                {
                    id: 59,
                    text: "K(Kelvin)",
                    short: "K",
                    full: "Kelvin",
                },
                {
                    id: 60,
                    text: "mol(Mole)",
                    short: "mol",
                    full: "Mole",
                },
                {
                    id: 61,
                    text: "cd(Candela)",
                    short: "cd",
                    full: "Candela",
                },
                {
                    id: 62,
                    text: "s(Sekunde)",
                    short: "s",
                    full: "Sekunde",
                },
                {
                    id: 63,
                    text: "Hz(Hertz)",
                    short: "Hz",
                    full: "Hertz",
                },
                {
                    id: 64,
                    text: "Pa(Pascal)",
                    short: "Pa",
                    full: "Pascal",
                },
                {
                    id: 65,
                    text: "N(Newton)",
                    short: "N",
                    full: "Newton",
                },
                {
                    id: 66,
                    text: "J(Joule)",
                    short: "J",
                    full: "Joule",
                },
                {
                    id: 67,
                    text: "W(Watt)",
                    short: "W",
                    full: "Watt",
                },
                {
                    id: 68,
                    text: "C(Coulomb)",
                    short: "C",
                    full: "Coulomb",
                },
                {
                    id: 69,
                    text: "V(Volt)",
                    short: "V",
                    full: "Volt",
                },
                {
                    id: 70,
                    text: "Ω(Ohm)",
                    short: "Ω",
                    full: "Ohm",
                },
                {
                    id: 71,
                    text: "F(Farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(Henry)",
                    short: "H",
                    full: "Henry",
                },
                {
                    id: 73,
                    text: "°C(Grad Celsius)",
                    short: "°C",
                    full: "Grad Celsius",
                },
                {
                    id: 74,
                    text: "rad(Radiant)",
                    short: "rad",
                    full: "Radiant",
                },
                {
                    id: 75,
                    text: "sr(Steradiant)",
                    short: "sr",
                    full: "Steradiant",
                },
            ],
            fr: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
            jp: [
                {
                    id: 0,
                    text: "なし",
                },
                {
                    id: 1,
                    text: "ページ単位",
                },
                {
                    id: 2,
                    text: "km(キロメートル)",
                    short: "km",
                    full: "キロメートル",
                },
                {
                    id: 3,
                    text: "hm(百メートル)",
                    short: "he",
                    full: "百メートル",
                },
                {
                    id: 4,
                    text: "dam(デカメートル)",
                    short: "dam",
                    full: "デカメートル",
                },
                {
                    id: 5,
                    text: "m(メートル)",
                    short: "m",
                    full: "メートル",
                },
                {
                    id: 6,
                    text: "dm(デシメートル)",
                    short: "dm",
                    full: "デシメートル",
                },
                {
                    id: 7,
                    text: "cm(センチメートル)",
                    short: "cm",
                    full: "センチメートル",
                },
                {
                    id: 8,
                    text: "mm(ミリメートル)",
                    short: "mm",
                    full: "ミリメートル",
                },
                {
                    id: 9,
                    text: "dmm(デシミリメートル)",
                    short: "dmm",
                    full: "デシミリメートル",
                },
                {
                    id: 10,
                    text: "cmm(センチミリメートル)",
                    short: "cmm",
                    full: "センチミリメートル",
                },
                {
                    id: 11,
                    text: "um(マイクロメートル)",
                    short: "um",
                    full: "マイクロメートル",
                },
                {
                    id: 12,
                    text: "n.m(海里)",
                    short: "n.m",
                    full: "海里",
                },
                {
                    id: 13,
                    text: "mi(マイル)",
                    short: "mi",
                    full: "マイル",
                },
                {
                    id: 14,
                    text: "yd(ヤード)",
                    short: "yd",
                    full: "ヤード",
                },
                {
                    id: 15,
                    text: "ft(フィート)",
                    short: "ft",
                    full: "フィート",
                },
                {
                    id: 16,
                    text: "in(インチ)",
                    short: "in",
                    full: "インチ",
                },
                {
                    id: 17,
                    text: "sq.km(平方キロメートル)",
                    short: "sq.km",
                    full: "平方キロメートル",
                },
                {
                    id: 18,
                    text: "ha(ヘクタール)",
                    short: "ha",
                    full: "ヘクタール",
                },
                {
                    id: 19,
                    text: "a(アール)",
                    short: "a",
                    full: "アール",
                },
                {
                    id: 20,
                    text: "sq.m(平方メートル)",
                    short: "sq.m",
                    full: "平方メートル",
                },
                {
                    id: 21,
                    text: "sq.cm(平方センチメートル)",
                    short: "sq.cm",
                    full: "平方センチメートル",
                },
                {
                    id: 22,
                    text: "sq.mi(平方マイル)",
                    short: "sq.mi",
                    full: "平方マイル",
                },
                {
                    id: 23,
                    text: "ac(エーカー)",
                    short: "ac",
                    full: "エーカー",
                },
                {
                    id: 24,
                    text: "sq.yd(平方ヤード)",
                    short: "sq.yd",
                    full: "平方ヤード",
                },
                {
                    id: 25,
                    text: "sq.ft(平方フィート)",
                    short: "sq.ft",
                    full: "平方フィート",
                },
                {
                    id: 26,
                    text: "sq.in(平方インチ)",
                    short: "sq.in",
                    full: "平方インチ",
                },
                {
                    id: 27,
                    text: "t(トン)",
                    short: "t",
                    full: "トン",
                },
                {
                    id: 28,
                    text: "q(キンタル)",
                    short: "q",
                    full: "キンタル",
                },
                {
                    id: 29,
                    text: "kg(キログラム)",
                    short: "kg",
                    full: "キログラム",
                },
                {
                    id: 30,
                    text: "hg(ヘクトグラム)",
                    short: "hg",
                    full: "ヘクトグラム",
                },
                {
                    id: 31,
                    text: "dag(デカグラム)",
                    short: "dag",
                    full: "デカグラム",
                },
                {
                    id: 32,
                    text: "g(グラム)",
                    short: "g",
                    full: "グラム",
                },
                {
                    id: 33,
                    text: "dg(デシグラム)",
                    short: "dg",
                    full: "デシグラム",
                },
                {
                    id: 34,
                    text: "cg(センチグラム)",
                    short: "cg",
                    full: "センチグラム",
                },
                {
                    id: 35,
                    text: "mg(ミリグラム)",
                    short: "mg",
                    full: "ミリグラム",
                },
                {
                    id: 36,
                    text: "ug(マイクログラム)",
                    short: "ug",
                    full: "マイクログラム",
                },
                {
                    id: 37,
                    text: "l.t(ロングトン)",
                    short: "l.t",
                    full: "ロングトン",
                },
                {
                    id: 38,
                    text: "s.t(ショートトン)",
                    short: "s.t",
                    full: "ショートトン",
                },
                {
                    id: 39,
                    text: "cwt(ハンドレッドウェイト)",
                    short: "cwt",
                    full: "ハンドレッドウェイト",
                },
                {
                    id: 40,
                    text: "stone(石)",
                    short: "stone",
                    full: "石",
                },
                {
                    id: 41,
                    text: "lb(ポンド)",
                    short: "lb",
                    full: "ポンド",
                },
                {
                    id: 42,
                    text: "oz(オンス)",
                    short: "oz",
                    full: "オンス",
                },
                {
                    id: 43,
                    text: "dr(ドラム)",
                    short: "dr",
                    full: "ドラム",
                },
                {
                    id: 44,
                    text: "gr(グレーン)",
                    short: "gr",
                    full: "グレーン",
                },
                {
                    id: 45,
                    text: "kl(キロリットル)",
                    short: "kl",
                    full: "キロリットル",
                },
                {
                    id: 46,
                    text: "hl(ヘクトリットル)",
                    short: "hl",
                    full: "ヘクトリットル",
                },
                {
                    id: 47,
                    text: "dal(デカリットル)",
                    short: "dal",
                    full: "デカリットル",
                },
                {
                    id: 48,
                    text: "l(リットル)",
                    short: "l",
                    full: "リットル",
                },
                {
                    id: 49,
                    text: "dl(デシリットル)",
                    short: "dl",
                    full: "デシリットル",
                },
                {
                    id: 50,
                    text: "cl(センチリットル)",
                    short: "cl",
                    full: "センチリットル",
                },
                {
                    id: 51,
                    text: "ml(ミリリットル)",
                    short: "ml",
                    full: "ミリリットル",
                },
                {
                    id: 52,
                    text: "ul(マイクロリットル)",
                    short: "ul",
                    full: "マイクロリットル",
                },
                {
                    id: 53,
                    text: "bsh(ブッシェル)",
                    short: "bsh",
                    full: "ブッシェル",
                },
                {
                    id: 54,
                    text: "pk(ペック)",
                    short: "pk",
                    full: "ペック",
                },
                {
                    id: 55,
                    text: "gal(ガロン)",
                    short: "gal",
                    full: "ガロン",
                },
                {
                    id: 56,
                    text: "qt(クォート)",
                    short: "qt",
                    full: "クォート",
                },
                {
                    id: 57,
                    text: "p(パイント)",
                    short: "p",
                    full: "パイント",
                },
                {
                    id: 58,
                    text: "A(アンペア)",
                    short: "A",
                    full: "アンペア",
                },
                {
                    id: 59,
                    text: "K(ケルビン)",
                    short: "K",
                    full: "ケルビン",
                },
                {
                    id: 60,
                    text: "mol(モル)",
                    short: "mol",
                    full: "モル",
                },
                {
                    id: 61,
                    text: "cd(カンデラ)",
                    short: "cd",
                    full: "カンデラ",
                },
                {
                    id: 62,
                    text: "s(秒)",
                    short: "s",
                    full: "秒",
                },
                {
                    id: 63,
                    text: "Hz(ヘルツ)",
                    short: "Hz",
                    full: "ヘルツ",
                },
                {
                    id: 64,
                    text: "Pa(パスカル)",
                    short: "Pa",
                    full: "パスカル",
                },
                {
                    id: 65,
                    text: "N(ニュートン)",
                    short: "N",
                    full: "ニュートン",
                },
                {
                    id: 66,
                    text: "J(ジュール)",
                    short: "J",
                    full: "ジュール",
                },
                {
                    id: 67,
                    text: "W(ワット)",
                    short: "W",
                    full: "ワット",
                },
                {
                    id: 68,
                    text: "C(クーロン)",
                    short: "C",
                    full: "クーロン",
                },
                {
                    id: 69,
                    text: "V(ボルト)",
                    short: "V",
                    full: "ボルト",
                },
                {
                    id: 70,
                    text: "Ω(オーム)",
                    short: "Ω",
                    full: "オーム",
                },
                {
                    id: 71,
                    text: "F(ファラド)",
                    short: "F",
                    full: "ファラド",
                },
                {
                    id: 72,
                    text: "H(ヘンリー)",
                    short: "H",
                    full: "ヘンリー",
                },
                {
                    id: 73,
                    text: "°C(摂氏)",
                    short: "°C",
                    full: "摂氏",
                },
                {
                    id: 74,
                    text: "rad(ラジアン)",
                    short: "rad",
                    full: "ラジアン",
                },
                {
                    id: 75,
                    text: "sr(ステラジアン)",
                    short: "sr",
                    full: "ステラジアン",
                },
            ],
            es: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
            it: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
            pt: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
            tw: [
                {
                    id: 0,
                    text: "None",
                },
                {
                    id: 1,
                    text: "Page's Unit",
                },
                {
                    id: 2,
                    text: "km(kilometre)",
                    short: "km",
                    full: "kilometre",
                },
                {
                    id: 3,
                    text: "hm(hectometre)",
                    short: "he",
                    full: "hectometre",
                },
                {
                    id: 4,
                    text: "dam(decametre)",
                    short: "dam",
                    full: "decametre",
                },
                {
                    id: 5,
                    text: "m(metre)",
                    short: "m",
                    full: "metre",
                },
                {
                    id: 6,
                    text: "dm(decimetre)",
                    short: "dm",
                    full: "decimetre",
                },
                {
                    id: 7,
                    text: "cm(centimetre)",
                    short: "cm",
                    full: "centimetre",
                },
                {
                    id: 8,
                    text: "mm(millimetre)",
                    short: "mm",
                    full: "millimetre",
                },
                {
                    id: 9,
                    text: "dmm(decimillimetre)",
                    short: "dmm",
                    full: "decimillimetre",
                },
                {
                    id: 10,
                    text: "cmm(centimillimetre)",
                    short: "cmm",
                    full: "centimillimetre",
                },
                {
                    id: 11,
                    text: "um(micrometre)",
                    short: "um",
                    full: "micrometre",
                },
                {
                    id: 12,
                    text: "n.m(nautical mile)",
                    short: "n.m",
                    full: "nautical mile",
                },
                {
                    id: 13,
                    text: "mi(mile)",
                    short: "mi",
                    full: "mile",
                },
                {
                    id: 14,
                    text: "yd(yard)",
                    short: "yd",
                    full: "yard",
                },
                {
                    id: 15,
                    text: "ft(foot)",
                    short: "ft",
                    full: "foot",
                },
                {
                    id: 16,
                    text: "in(inch)",
                    short: "in",
                    full: "inch",
                },
                {
                    id: 17,
                    text: "sq.km(square kilometre)",
                    short: "sq.km",
                    full: "square kilometre",
                },
                {
                    id: 18,
                    text: "ha(hectare)",
                    short: "ha",
                    full: "hectare",
                },
                {
                    id: 19,
                    text: "a(are)",
                    short: "a",
                    full: "are",
                },
                {
                    id: 20,
                    text: "sq.m(squrae metre)",
                    short: "sq.m",
                    full: "squrae metre",
                },
                {
                    id: 21,
                    text: "sq.cm(square centimetre)",
                    short: "sq.cm",
                    full: "square centimetre",
                },
                {
                    id: 22,
                    text: "sq.mi(square mile)",
                    short: "sq.mi",
                    full: "square mile",
                },
                {
                    id: 23,
                    text: "ac(acre)",
                    short: "ac",
                    full: "acre",
                },
                {
                    id: 24,
                    text: "sq.yd(square yard)",
                    short: "sq.yd",
                    full: "square yard",
                },
                {
                    id: 25,
                    text: "sq.ft(square foot)",
                    short: "sq.ft",
                    full: "square foot",
                },
                {
                    id: 26,
                    text: "sq.in(square inch)",
                    short: "sq.in",
                    full: "square inch",
                },
                {
                    id: 27,
                    text: "t(tonne)",
                    short: "t",
                    full: "tonne",
                },
                {
                    id: 28,
                    text: "q(quintal)",
                    short: "q",
                    full: "quintal",
                },
                {
                    id: 29,
                    text: "kg(kilogram)",
                    short: "kg",
                    full: "kilogram",
                },
                {
                    id: 30,
                    text: "hg(hectogramme)",
                    short: "hg",
                    full: "hectogramme",
                },
                {
                    id: 31,
                    text: "dag(decagramme)",
                    short: "dag",
                    full: "decagramme",
                },
                {
                    id: 32,
                    text: "g(gramme)",
                    short: "g",
                    full: "gramme",
                },
                {
                    id: 33,
                    text: "dg(decigramme)",
                    short: "dg",
                    full: "decigramme",
                },
                {
                    id: 34,
                    text: "cg(centigramme)",
                    short: "cg",
                    full: "centigramme",
                },
                {
                    id: 35,
                    text: "mg(milligramme)",
                    short: "mg",
                    full: "milligramme",
                },
                {
                    id: 36,
                    text: "ug(microgramme)",
                    short: "ug",
                    full: "microgramme",
                },
                {
                    id: 37,
                    text: "l.t(long ton)",
                    short: "l.t",
                    full: "long ton",
                },
                {
                    id: 38,
                    text: "s.t(short ton)",
                    short: "s.t",
                    full: "short ton",
                },
                {
                    id: 39,
                    text: "cwt(hundredweight)",
                    short: "cwt",
                    full: "hundredweight",
                },
                {
                    id: 40,
                    text: "stone(stone)",
                    short: "stone",
                    full: "stone",
                },
                {
                    id: 41,
                    text: "lb(pound)",
                    short: "lb",
                    full: "pound",
                },
                {
                    id: 42,
                    text: "oz(ounce)",
                    short: "oz",
                    full: "ounce",
                },
                {
                    id: 43,
                    text: "dr(dram)",
                    short: "dr",
                    full: "dram",
                },
                {
                    id: 44,
                    text: "gr(grain)",
                    short: "gr",
                    full: "grain",
                },
                {
                    id: 45,
                    text: "kl(kilolitre)",
                    short: "kl",
                    full: "kilolitre",
                },
                {
                    id: 46,
                    text: "hl(hectolitre)",
                    short: "hl",
                    full: "hectolitre",
                },
                {
                    id: 47,
                    text: "dal(decalitre)",
                    short: "dal",
                    full: "decalitre",
                },
                {
                    id: 48,
                    text: "l(litre)",
                    short: "l",
                    full: "litre",
                },
                {
                    id: 49,
                    text: "dl(decilitre)",
                    short: "dl",
                    full: "decilitre",
                },
                {
                    id: 50,
                    text: "cl(centilitre)",
                    short: "cl",
                    full: "centilitre",
                },
                {
                    id: 51,
                    text: "ml(millilitre)",
                    short: "ml",
                    full: "millilitre",
                },
                {
                    id: 52,
                    text: "ul(microlitre)",
                    short: "ul",
                    full: "microlitre",
                },
                {
                    id: 53,
                    text: "bsh(microlitre)",
                    short: "bsh",
                    full: "microlitre",
                },
                {
                    id: 54,
                    text: "pk(peck)",
                    short: "pk",
                    full: "peck",
                },
                {
                    id: 55,
                    text: "gal(gallon)",
                    short: "gal",
                    full: "gallon",
                },
                {
                    id: 56,
                    text: "qt(quart)",
                    short: "qt",
                    full: "quart",
                },
                {
                    id: 57,
                    text: "p(pint)",
                    short: "p",
                    full: "pint",
                },
                {
                    id: 58,
                    text: "A(ampere)",
                    short: "A",
                    full: "ampere",
                },
                {
                    id: 59,
                    text: "K(kelvin)",
                    short: "K",
                    full: "kelvin",
                },
                {
                    id: 60,
                    text: "mol(mole)",
                    short: "mol",
                    full: "mole",
                },
                {
                    id: 61,
                    text: "cd(candela)",
                    short: "cd",
                    full: "candela",
                },
                {
                    id: 62,
                    text: "s(second)",
                    short: "s",
                    full: "second",
                },
                {
                    id: 63,
                    text: "Hz(hertz)",
                    short: "Hz",
                    full: "hertz",
                },
                {
                    id: 64,
                    text: "Pa(pascal)",
                    short: "Pa",
                    full: "pascal",
                },
                {
                    id: 65,
                    text: "N(newton)",
                    short: "N",
                    full: "newton",
                },
                {
                    id: 66,
                    text: "J(joule)",
                    short: "J",
                    full: "joule",
                },
                {
                    id: 67,
                    text: "W(watt)",
                    short: "W",
                    full: "watt",
                },
                {
                    id: 68,
                    text: "C(coulomb)",
                    short: "C",
                    full: "coulomb",
                },
                {
                    id: 69,
                    text: "V(volt)",
                    short: "V",
                    full: "volt",
                },
                {
                    id: 70,
                    text: "Ω(ohm)",
                    short: "Ω",
                    full: "ohm",
                },
                {
                    id: 71,
                    text: "F(farad)",
                    short: "F",
                    full: "farad",
                },
                {
                    id: 72,
                    text: "H(henry)",
                    short: "H",
                    full: "henry",
                },
                {
                    id: 73,
                    text: "°C(centigrade)",
                    short: "°C",
                    full: "centigrade",
                },
                {
                    id: 74,
                    text: "rad(radian)",
                    short: "rad",
                    full: "radian",
                },
                {
                    id: 75,
                    text: "sr(steradian)",
                    short: "sr",
                    full: "steradian",
                },
            ],
        };
        dateList: Array<object> = [
            {
                id: 0,
                text: "2019-01-31",
                value: "yyyy-MM-dd",
            },
            {
                id: 1,
                text: "2019/1/31",
                value: "yyyy/M/d",
            },
            {
                id: 2,
                text: "1/31/2019",
                value: "M/d/yyyy",
            },
            {
                id: 3,
                text: "1/31/19",
                value: "M/d/yy",
            },
            {
                id: 4,
                text: "31/1/2019",
                value: "d/M/yyyy",
            },
            {
                id: 5,
                text: "31/1/19",
                value: "d/M/yy",
            },
            {
                id: 6,
                text: "1.31.2019",
                value: "M.d.yyyy",
            },
            {
                id: 7,
                text: "31.1.2019",
                value: "d.M.yyyy",
            },
            {
                id: 8,
                text: "19-1-31",
                value: "yy-M-d",
            },
            {
                id: 9,
                text: "01-31-19",
                value: "MM-dd-yy",
            },
            {
                id: 10,
                text: "dateList[0]",
                value: "MMMM d,yyyy",
            },
            {
                id: 11,
                text: "dateList[1]",
                value: "dddd,MMMM dd,yyyy",
            },
            {
                id: 12,
                text: "dateList[2]",
                value: "d MMMM yyyy",
            },
            {
                id: 13,
                text: "dateList[3]",
                value: "d-MMM-yy",
            },
            {
                id: 14,
                text: "dateList[4]",
                value: "MMM.d,yy",
            },
            {
                id: 15,
                text: "dateList[5]",
                value: "MMMM yy",
            },
            {
                id: 16,
                text: "dateList[6]",
                value: "MMM-yy",
            },
            {
                id: 17,
                text: "2019",
                value: "yyyy",
            },
            {
                id: 18,
                text: "dateList[7]",
                value: "MMM",
            },
            {
                id: 19,
                text: "dateList[8]",
                value: "M/d/yyyy h:mm:ss ap",
            },
            {
                id: 20,
                text: "dateList[9]",
                value: "M/d/yyyy h:mm ap",
            },
            {
                id: 21,
                text: "dateList[10]",
                value: "d/M/yyyy h:mm:ss ap",
            },
            {
                id: 22,
                text: "dateList[11]",
                value: "d/M/yyyy h:mm ap",
            },
            {
                id: 23,
                text: "dateList[12]",
                value: "h:mm ap",
            },
            {
                id: 24,
                text: "dateList[13]",
                value: "h:mm:ss ap",
            },
            {
                id: 25,
                text: "10:20",
                value: "hh:mm",
            },
            {
                id: 26,
                text: "10:20:30",
                value: "hh:mm:ss",
            },
            {
                id: 27,
                text: "10",
                value: "hh",
            },
            {
                id: 28,
                text: "20",
                value: "mm",
            },
            {
                id: 29,
                text: "30",
                value: "ss",
            },
        ];
        durationList: Array<object> = [
            {
                id: 0,
                text: "4 w.",
                value: '[w] "w."',
            },
            {
                id: 1,
                text: "4.6 w.",
                value: '[ww] "w."',
            },
            {
                id: 2,
                text: "4 w. 6 d.",
                value: '[w] "w." [d] "d."',
            },
            {
                id: 3,
                text: "12 d.",
                value: '[d] "d."',
            },
            {
                id: 4,
                text: "12.5 d.",
                value: '[dd] "d."',
            },
            {
                id: 5,
                text: "12 d. 12 h.",
                value: '[d] "d." [h] "h."',
            },
            {
                id: 6,
                text: "51 h.",
                value: '[h] "h."',
            },
            {
                id: 7,
                text: "51.3 h.",
                value: '[hh] "h."',
            },
            {
                id: 8,
                text: "51 h. 18 m.",
                value: '[h] "h." [mm] "m."',
            },
            {
                id: 9,
                text: "200 m.",
                value: '[mm] "m."',
            },
            {
                id: 10,
                text: "200 m. 9 s.",
                value: '[mm] "m." [ss] "s."',
            },
            {
                id: 11,
                text: "12009 s.",
                value: '[ss] "s."',
            },
        ];
        curListText: object = {
            zh: ["澳大利亚元", "加元", "丹麦克朗", "欧元", "港元", "日元", "英镑", "瑞典克朗", "美元", "元", "卢比", "韩元", "马元", "比索", "兰特"],
            en: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
            de: [
                "Australischer Dollar",
                "Kanadischer Dollar",
                "Dänische Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanische YEN",
                "Pfund Sterling",
                "Schwedische Krone",
                "US Dollar",
                "Yuan RMB",
                "Indische Rupie",
                "Südkoreanischer Won",
                "Malaysischer Ringgit",
                "Mexikanischer Peso",
                "Südafrikanischer Rand",
            ],
            fr: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
            jp: [
                "豪ドル",
                "カナダドル",
                "デンマーク・クローネ",
                "ユーロ",
                "香港ドル",
                "日本円",
                "英ポンド",
                "スウェーデン・クローナ",
                "ドル",
                "人民幣",
                "インドルピー",
                "韓国ウォン",
                "マレーシアリンギット",
                "メキシコペソ",
                "南アフリカランド",
            ],
            es: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
            it: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
            pt: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
            tw: [
                "Australian Dollar",
                "Canadian Dollar",
                "Danish Krone",
                "Euro",
                "Hong Kong Dollar",
                "Japanese yen",
                "Pound Sterling",
                "Swedish Krona",
                "US Dollar",
                "Yuan Renminbi",
                "Indian Rupee",
                "South Korean Won",
                "Malaysian Ringgit",
                "Mexican Peso",
                "South African Rand",
            ],
        };
        curListShort: Array<string> = ["AUD", "CAD", "DKK", "EUR", "HKD", "JPY", "GBP", "SEK", "USD", "CNY", "INR", "KRW", "MYR", "MXN", "ZAR"];
        curListSymbol: Array<string> = ["$A.", "$", "D.Kr.", "€", "HK$", "¥", "£", "S.Kr.", "$", "￥", "Re.", "KRW", "M.$", "$", "R."];
        decimalList: Array<string> = ["0", "0.0", "0.00", "0.000", "0.0000", "0.00000", "0.000000"];
        tempList: Array<any> = [];

        get showShapeData() {
            return this.$store.state.dialog.showShapeData;
        }

        // ul dropdown list
        getNumberOption() {
            // 左侧数字下拉列表
            let str = this.decimalInput;
            if (this.clickCheckbox) {
                str = "#,###" + str;
            }
            return str;
        }
        getCurrencyRight(id) {
            // 右侧货币下拉列表
            return `${this.curListShort[id]}[${this.curListSymbol[id]}][${this.curListText[this.lang][id]}]`;
        }
        getCurrencyLeft() {
            let num = this.clickCurrencyUnit;
            let str = this.getNumberOption();
            if (num != -1) {
                return [
                    {
                        id: 0,
                        text: `${this.curListSymbol[num]} 1980`,
                        value: `"${this.curListSymbol[num]}"${str}`,
                    },
                    {
                        id: 1,
                        text: `${this.curListShort[num]} 1980`,
                        value: `"${this.curListShort[num]}"${str}`,
                    },
                    {
                        id: 2,
                        text: `1980 ${this.curListShort[num]}`,
                        value: `${str}"${this.curListShort[num]}"`,
                    },
                    {
                        id: 3,
                        text: `1980 ${this.curListText[this.lang][num]}`,
                        value: `${str}"${this.curListText[this.lang][num]}"`,
                    },
                ];
            }
            return [];
        }

        // function
        changeToStringDate(str) {
            let date = new Date(str);
            let Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            return `${Y}-${M}-${D}`;
        }
        displayString(_value, _format, _type): string {
            let res: string;
            switch (_type) {
                case EDProperty.eType.String:
                    res = EDFormat.stringToString(_value || "", _format, _type);
                    break;
                case EDProperty.eType.Number:
                    let value = EDFormat.numberFromString(_value.toString(), _format, _type);
                    res = EDFormat.numberToString(value, _format, _type);
                    break;
                case EDProperty.eType.Date:
                    res = EDFormat.numberToString(EDFormat.daysFromDateString(_value)[0], _format, _type);
                    if (this.lang == "zh") {
                        res = res.replace(/am/g, "上午");
                        res = res.replace(/pm/g, "下午");
                    }
                    break;
                case EDProperty.eType.Duration:
                    res = EDFormat.numberToString(+_value, _format, _type);
                    break;
                case EDProperty.eType.Currency:
                    res = EDFormat.numberToString(parseFloat(_value), _format, _type);
                    break;
                case EDProperty.eType.Boolean:
                    res = EDFormat.numberToString(_value, _format, _type);
                    break;
                case EDProperty.eType.FixedList:
                    if (_format.length == 0) {
                        res = "Fixed List";
                    } else {
                        res = EDFormat.stringFromString(_value, _format, _type);
                    }
                    break;
                case EDProperty.eType.Percentage:
                    res = EDFormat.numberToString(_value, _format, _type);
                    break;
                case EDProperty.eType.Scientific:
                    res = EDFormat.numberToString(_value, _format, _type);
                    break;
                case EDProperty.eType.Image:
                    res = "Picture";
                    break;
                case EDProperty.eType.Formula:
                    res = _value;
                    break;
                default:
                    {
                        // color and others
                        res = _value;
                    }
                    break;
            }
            return res;
        }
        getPreview() {
            let data = this.tempList[this.clickIndex];
            if (data["type"] == 8) {
                if (!/^#[0-9a-fA-F]{6}$/.test(data["value"])) {
                    data["value"] = "#ffffff";
                }
            }
            let str = this.displayString(data["value"] || 0, data["format"], data["type"]);
            // debugger
            console.log(str);
            this.previewFormat = str;
        }
        getDataIndex() {
            // 获取数据索引
            let num = -1;
            for (let i = 0; i < this.tempList.length; ++i) {
                if (this.clickID == this.tempList[i]["id"]) {
                    num = i;
                }
            }
            return num;
        }
        cleanData() {
            // 还原数据为初始状态
            this.clickID = 0;
            this.clickType = "";
            this.clickString = 0;
            this.clickNumber = 0;
            this.clickDateTime = 0;
            this.clickDuration = 0;
            this.clickCurrency = -1;
            this.disabled = false;

            this.clickCheckbox = false;
            this.clickUnit = 0;
            this.clickCurrencyUnit = -1;
            this.clickDecimal = 0;

            this.decimalInput = "0";
            this.nameInput = "";
            this.numberInput = "0";
            this.dateInput = "2019-01-01";
            this.timeInput = "";
            this.colorInput = "";
            this.percentInput = "0%";
            this.valueNumberInput = 0;
            this.formatInput = "";
            this.valueInput = "";
            this.descriptionInput = "";
        }
        selectItem(id) {
            // 选择底部数据后渲染顶部的数据
            this.cleanData();
            this.clickID = id;
            this.clickIndex = this.getDataIndex();
            this.nameInput = this.tempList[this.clickIndex]?.["transName"] || this.tempList[this.clickIndex]?.["name"] || "";
            this.clickType = this.typeList[this.tempList[this.clickIndex]["type"]]["value"];
            this.formatInput = this.tempList[this.clickIndex]["format"];
            this.valueInput = this.tempList[this.clickIndex]["value"] && this.tempList[this.clickIndex]["value"].toString();
            this.descriptionInput = this.tempList[this.clickIndex]["description"];
            this.disabled = this.tempList[this.clickIndex]["disabled"] || false;

            this.clickDecimal = this.tempList[this.clickIndex]["decimalIndex"] || 0;
            this.clickCurrencyUnit = this.tempList[this.clickIndex]["currencyIndex"] || 0;
            this.clickUnit = this.tempList[this.clickIndex]["unitIndex"] || 0;
            this.clickCheckbox = this.tempList[this.clickIndex]["isCheck"] || false;
            if (this.clickType == "string") {
                this.clickString = this.tempList[this.clickIndex]["formatIndex"] || 0;
            } else if (this.clickType == "number") {
                this.clickNumber = this.tempList[this.clickIndex]["formatIndex"] || 0;
                this.valueNumberInput = parseFloat(this.tempList[this.clickIndex]["value"]) || 0;
                this.changeOption("decimal");
            } else if (this.clickType == "dateTime") {
                let arr = this.valueInput.split(" ") || [];
                this.dateInput = arr.length > 0 ? arr[0] : "2019-01-01";
                this.timeInput = arr.length > 0 ? arr[1] : "00:00:00";
                this.clickDateTime = this.tempList[this.clickIndex]["formatIndex"] || 0;
            } else if (this.clickType == "duration") {
                this.clickDuration = this.tempList[this.clickIndex]["formatIndex"] || 0;
            } else if (this.clickType == "currency") {
                this.clickCurrency = this.tempList[this.clickIndex]["formatIndex"] || 0;
                this.valueNumberInput = parseFloat(this.tempList[this.clickIndex]["value"]) || 0;
                this.changeOption("decimal");
            } else if (this.clickType == "list") {
                this.clickList = this.formatInput;
            } else if (this.clickType == "color") {
                if (!/^#[0-9a-fA-F]{6}$/.test(this.valueInput)) {
                    this.colorInput = "#ffffff";
                    this.tempList[this.clickIndex]["value"] = "#ffffff";
                } else {
                    this.colorInput = this.valueInput;
                }
            } else if (this.clickType == "percentage") {
                this.valueNumberInput = parseFloat(this.tempList[this.clickIndex]["value"]) || 0;
                this.changeOption("decimal");
            } else if (this.clickType == "scientific") {
                this.valueNumberInput = parseFloat(this.tempList[this.clickIndex]["value"]) || 0;
                this.clickScientific = this.tempList[this.clickIndex]["formatIndex"];
                this.changeOption("decimal");
            } else if (this.clickType == "boolean") {
                if (!["false", "true"].includes(this.valueInput)) {
                    this.valueInput = "false";
                }
            }
            this.getPreview();
        }
        setDate(name) {
            this.dateInput = name;
            this.valueInput = this.dateInput + " " + this.timeInput;
            this.changeItem("value");
        }
        setTime(name) {
            this.timeInput = name;
            this.valueInput = this.dateInput + " " + this.timeInput;
            this.changeItem("value");
        }
        changeOption(type) {
            // 右侧改变内容
            if (["decimal", "checkbox", "unit"].includes(type)) {
                this.decimalInput = this.decimalList[this.clickDecimal];
                if (this.clickNumber != 0 && this.clickUnit > 1) {
                    this.numberInput =
                        this.getNumberOption() + '"' + this.unitList[this.lang][this.clickUnit][this.clickNumber == 1 ? "short" : "full"] + '"';
                } else if (this.clickUnit == 1) {
                    this.numberInput = this.getNumberOption() + '"' + this.pageUnit + '"';
                } else {
                    this.numberInput = this.getNumberOption();
                }
            }
            if (type == "decimal") {
                this.tempList[this.clickIndex]["decimalIndex"] = this.clickDecimal;
                this.percentInput = this.decimalList[this.clickDecimal] + "%"; // 设置百分数小数位
            }
            if (type == "checkbox") {
                this.tempList[this.clickIndex]["isCheck"] = this.clickCheckbox;
            }
            if (type == "unit") {
                this.tempList[this.clickIndex]["unitIndex"] = this.clickUnit;
                this.tempList[this.clickIndex]["currencyIndex"] = this.clickCurrencyUnit;
                this.tempList[this.clickIndex]["type"] == 1 &&
                    (this.tempList[this.clickIndex]["unit"] = this.unitList[this.lang][this.clickUnit]["short"]);
                this.tempList[this.clickIndex]["type"] == 4 && (this.tempList[this.clickIndex]["unit"] = this.curListShort[this.clickCurrencyUnit]);
            }
            this.changeItem("format");
        }
        changeItem(type) {
            if (this.clickID == -1) {
                return;
            }
            if (["name", "type", "format", "value", "description"].includes(type)) {
                let map = new Map([
                    [
                        "name",
                        () => {
                            this.changeName();
                        },
                    ],
                    [
                        "type",
                        () => {
                            this.changeType();
                        },
                    ],
                    [
                        "format",
                        () => {
                            this.changeFormat();
                        },
                    ],
                    [
                        "description",
                        () => {
                            this.changeDescription();
                        },
                    ],
                    [
                        "value",
                        () => {
                            this.changeValue();
                        },
                    ],
                ]);
                map.get(type)();
            }
        }
        changeName() {
            // 改变名称
            this.tempList[this.clickIndex]["name"] = this.nameInput;
            this.tempList[this.clickIndex]["transName"] = this.nameInput;
            this.tempList[this.clickIndex]["disable"] = false;
        }
        changeType() {
            // 改变选择类型
            let typeNum = 0;
            for (let i = 0; i < this.typeList.length; ++i) {
                if (this.typeList[i]["value"] == this.clickType) {
                    typeNum = i;
                }
            }
            if (this.tempList[this.clickIndex]) {
                this.tempList[this.clickIndex]["type"] = typeNum;
            }
            this.selectItem(this.clickID);
            this.changeItem("format");
            this.changeItem("value");
        }
        changeFormat() {
            // 改变格式
            if (this.clickType == "string") {
                if (this.clickString != undefined) {
                    this.formatInput = this.stringList[this.clickString]["value"];
                } else {
                    this.formatInput = "@";
                    this.clickString = 0;
                }
                this.tempList[this.clickIndex]["formatIndex"] = this.clickString;
            } else if (this.clickType == "number") {
                this.formatInput = this.numberInput;
                this.tempList[this.clickIndex]["formatIndex"] = this.clickNumber;
                // if(this.)
                if (isNaN(Number(this.clickNumber))) {
                    this.clickNumber = 0;
                }
            } else if (this.clickType == "dateTime") {
                if (!/\d{4}-\d{2}-\d{2}/.test(this.dateInput)) {
                    this.dateInput = "2019-01-01";
                }
                if (!/\d{2}:\d{2}:\d{2}/.test(this.timeInput)) {
                    this.timeInput = "00:00:00";
                }
                this.formatInput = this.clickDateTime != undefined ? this.dateList[this.clickDateTime]["value"] : "";
                this.tempList[this.clickIndex]["formatIndex"] = this.clickDateTime;
            } else if (this.clickType == "duration") {
                this.formatInput = this.clickDuration != undefined ? this.durationList[this.clickDuration]["value"] : "";
                this.tempList[this.clickIndex]["formatIndex"] = this.clickDuration;
            } else if (this.clickType == "currency") {
                let arr = this.getCurrencyLeft();
                this.formatInput = arr.length > 0 && this.clickCurrency >= 0 ? arr[this.clickCurrency]["value"] : this.getNumberOption();
                this.tempList[this.clickIndex]["formatIndex"] = this.clickCurrency;
            } else if (this.clickType == "boolean") {
                this.formatInput = "";
            } else if (this.clickType == "list") {
                if (!/\;/.test(this.clickList)) {
                    this.clickList = "";
                }
                this.formatInput = this.clickList;
            } else if (this.clickType == "color") {
                this.formatInput = "";
            } else if (this.clickType == "percentage") {
                this.formatInput = this.percentInput;
            } else if (this.clickType == "scientific") {
                this.formatInput = this.clickScientific == 0 ? this.decimalInput + "e+0" : this.decimalInput + "e+00";
                this.tempList[this.clickIndex]["formatIndex"] = this.clickScientific;
            }
            this.tempList[this.clickIndex]["format"] = this.formatInput;
            this.getPreview();
        }
        changeValue() {
            // 改变值
            if (this.clickType == "color" && /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(this.colorInput)) {
                // #000 类型
                this.tempList[this.clickIndex]["value"] = this.colorInput;
            } else if (["number", "currency", "percentage", "scientific"].includes(this.clickType)) {
                // number 类型
                this.tempList[this.clickIndex]["value"] = this.valueNumberInput;
            } else if (this.clickType == "boolean") {
                // boolean 类型
                this.tempList[this.clickIndex]["value"] = this.valueInput == "false" ? false : true;
            } else if (this.clickType == "duration") {
                // duration 类型
                if (/^\d+$/.test(this.valueInput)) {
                    this.tempList[this.clickIndex]["value"] = this.valueInput;
                } else {
                    this.valueInput = "0";
                    this.tempList[this.clickIndex]["value"] = "0";
                }
            } else if (this.clickType == "dateTime") {
                // dateTime 类型
                if (!/\d{4}-\d{2}-\d{2}/.test(this.dateInput)) {
                    this.dateInput = "2019-01-01";
                    this.tempList[this.clickIndex]["value"] = `${this.dateInput} ${this.timeInput}`;
                } else {
                    let dateStr = this.changeToStringDate(this.dateInput);
                    this.tempList[this.clickIndex]["value"] = `${dateStr} ${this.timeInput}`;
                }
            } else if (this.clickType == "list") {
                // list 类型
                let list = this.tempList[this.clickIndex]["format"].split(";");
                let transList = this.tempList[this.clickIndex]["transFormat"].split(";");
                let index = transList.indexOf(this.valueInput);
                this.tempList[this.clickIndex]["transValue"] = this.valueInput;
                if (index != -1) {
                    this.tempList[this.clickIndex]["value"] = list[index];
                } else {
                    this.tempList[this.clickIndex]["value"] = this.valueInput;
                }
            } else {
                // string
                this.tempList[this.clickIndex]["value"] = this.valueInput;
            }
            this.getPreview();
        }
        changeDescription() {
            this.tempList[this.clickIndex]["description"] = this.descriptionInput;
        }
        addItem() {
            let idList = this.tempList.map((v, k) => v["id"]);
            let temp = {
                id: 1,
                name: "xxx0",
                type: 0,
                format: "@",
                formatIndex: 0,
                value: "",
                decimal: 0,
                description: "",
            };
            let tempID = this.tempList.length + 1;
            while (idList.includes(tempID)) {
                tempID++;
            }
            temp.id = tempID;
            temp.name = (this.$t("property") as string) + (this.tempList.length + 1);
            this.tempList.push(temp);
            this.selectItem(tempID);
        }
        delItem() {
            if (!this.clickID || this.clickID == -1 || this.tempList.length <= 1) {
                return;
            }
            this.tempList.splice(this.clickIndex, 1);
            !!this.clickIndex && --this.clickIndex;
            this.clickID = this.tempList[this.clickIndex]["id"];
            this.selectItem(this.clickID);
        }
        moveItem(type) {
            if (type == "up") {
                if (this.clickIndex < 1) return;
                let temp = JSON.parse(JSON.stringify(this.tempList[this.clickIndex]));
                this.tempList.splice(this.clickIndex, 1, this.tempList[this.clickIndex - 1]);
                this.tempList.splice(this.clickIndex - 1, 1, temp);
                this.clickIndex--;
            } else if (type == "down") {
                let temp = JSON.parse(JSON.stringify(this.tempList[this.clickIndex]));
                this.tempList.splice(this.clickIndex, 1, this.tempList[this.clickIndex + 1]);
                this.tempList.splice(this.clickIndex + 1, 1, temp);
                this.clickIndex++;
            }
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        showColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.OnceColor,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "OnceColor" });
            });
        }
        initIndex(arr) {
            // 初始化索引信息
            let tL = this.typeList;
            for (let i = 0; i < arr.length; ++i) {
                let dataType = tL[arr[i]["type"]]["value"];
                this.clickType = dataType;
                if (dataType == "string") {
                    for (let j = 0; j < this.stringList.length; ++j) {
                        if (arr[i]["format"] == this.stringList[j]["value"]) {
                            arr[i].formatIndex = j;
                            break;
                        }
                    }
                } else if (dataType == "number") {
                    let unit = arr[i]["format"].replace(/.*"(.*)"/gi, "$1");
                    arr[i].isCheck = /(#,###)/g.test(arr[i]["format"]);
                    if (unit) {
                        let flag = false;
                        for (let k = 0; k < this.unitList[this.lang].length; ++k) {
                            if (unit.toLowerCase() == this.unitList[this.lang][k]["short"]) {
                                arr[i].unitIndex = k;
                                arr[i].formatIndex = 1;
                                flag = true;
                                break;
                            }
                        }
                        if (!flag) {
                            for (let k = 0; k < this.unitList[this.lang].length; ++k) {
                                if (unit.toLowerCase() == this.unitList[this.lang][k]["full"]) {
                                    arr[i].unitIndex = k;
                                    arr[i].formatIndex = 2;
                                    break;
                                }
                            }
                        }
                    } else {
                        arr[i].formatIndex = 0;
                    }
                } else if (dataType == "dateTime") {
                    for (let j = 0; j < this.dateList.length; ++j) {
                        if (arr[i]["format"] == this.dateList[j]["value"]) {
                            arr[i].formatIndex = j;
                            break;
                        }
                    }
                } else if (dataType == "duration") {
                    for (let j = 0; j < this.durationList.length; ++j) {
                        if (arr[i]["format"] == this.durationList[j]["value"]) {
                            arr[i].formatIndex = j;
                            break;
                        }
                    }
                } else if (dataType == "currency") {
                    let currency = /\"(.*)\"/g.exec(arr[i]["format"]) && /\"(.*)\"/g.exec(arr[i]["format"])[1];
                    arr[i].isCheck = /(#,###)/g.test(arr[i]["format"]);
                    if (currency) {
                        let flag = false;
                        for (let k = 0; k < this.curListSymbol.length; ++k) {
                            if (currency == this.curListSymbol[k]) {
                                arr[i].currencyIndex = k;
                                arr[i].formatIndex = 0;
                                flag = true;
                                break;
                            }
                        }
                        if (!flag) {
                            for (let k = 0; k < this.curListShort.length; ++k) {
                                if (currency == this.curListShort[k]) {
                                    arr[i].currencyIndex = k;
                                    if (arr[i]["format"].match(currency) && arr[i]["format"].match(currency).index == 1) {
                                        arr[i].formatIndex = 1;
                                    } else {
                                        arr[i].formatIndex = 2;
                                    }
                                    flag = true;
                                    break;
                                }
                            }
                        }
                        if (!flag) {
                            for (let k = 0; k < this.curListText[this.lang].length; ++k) {
                                if (currency == this.curListText[this.lang][k]) {
                                    arr[i].currencyIndex = k;
                                    arr[i].formatIndex = 3;
                                    flag = true;
                                    break;
                                }
                            }
                        }
                    }
                } else if (dataType == "boolean") {
                } else if (dataType == "scientific") {
                    let num = arr[i]["format"].split("+")[1].length;
                    arr[i].formatIndex = num - 1;
                }
                if (["number", "currency", "percentage", "scientific"].includes(dataType)) {
                    let numDecimal = arr[i]["format"].replace(/[^0-9\.]/gi, "");
                    for (let j = 0; j < this.decimalList.length; ++j) {
                        if (numDecimal == this.decimalList[j]) {
                            arr[i].decimalIndex = j;
                            break;
                        }
                    }
                }
            }
        }
        initTableWidth() {
            let children = (this.$refs.tableSrcoll as HTMLElement).children[0] as HTMLElement;
            if (children) {
                this.tableWidth = children.offsetWidth + "px";
            }
        }
        confirm() {
            if (this.showShapeData) {
                // 设置卡片信息
                this.orgShapeCardData = this.tempList;
            } else {
                this.shapeDataList = this.tempList;
                window["_view"].updateShapeProp(this.tempList);
            }

            this.closeModal();
        }
        closeModal() {
            this.tempList = [];
            if (this.showShapeData) {
                this.$store.commit("setDialogState", {
                    type: "showShapeData",
                    data: false,
                });
            } else {
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
            }
        }
        @Watch("onceColor")
        watchColor(val) {
            if (val && /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(val)) {
                this.tempList[this.clickIndex]["value"] = val;
                this.colorInput = val;
                this.getPreview();
            }
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get onceColor() {
            return this.$store.state.ui.onceColor;
        }
        get colorValue() {
            let color = this.tempList[this.clickIndex]["value"];
            if (/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(color)) {
                return color;
            } else {
                return "#fff";
            }
        }
        get shapeDataList() {
            return this.$store.state.shape.shapeData;
        }
        set shapeDataList(v) {
            this.$store.commit("setShapeStatus", {
                type: "shapeData",
                data: v,
            });
        }
        get orgShapeCardData() {
            return this.$store.state.shape.orgShapeCardData;
        }
        set orgShapeCardData(v) {
            this.$store.commit("setShapeStatus", {
                type: "orgShapeCardData",
                data: v,
            });
        }
        get pageUnit() {
            let pageUnitList = ["mm", "cm", "m", "km", "in", "ft and in", "ft", "yd", "mi", "Points", "Pica", "Didot", "Cicero", "px"];
            return pageUnitList[this.$store.state.page.pageUnit];
        }
        get shapeDataID() {
            return this.$store.state.shape.shapeDataID;
        }
        mounted() {
            this.tempList = this.showShapeData ? JSON.parse(JSON.stringify(this.orgShapeCardData)) : JSON.parse(JSON.stringify(this.shapeDataList));
            if (this.tempList.length > 0) {
                this.initIndex(this.tempList);
            } else {
                // 无初始数据，自动添加一个
                this.addItem();
            }
            this.$nextTick(() => {
                // 获取底部表格内部宽度
                this.initTableWidth();
                let ID = this.shapeDataID < 0 ? this.tempList[0]["id"] : this.shapeDataID;
                this.selectItem(ID);
            });
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "自定义域",
    "domaintitle": "定义形状属性",
    "confirm": "确定",
    "cancel": "取消",
    "property": "属性",
    "name": "名称",
    "type": "类型",
    "format": "格式",
    "value": "值",
    "preview": "预览",
    "description": "说明",
    "data": "数据",
    "addItem": "新建",
    "delItem": "删除",
    "decimal": "小数位",
    "separator": "使用千位分隔符",
    "unit-currency": "单位/货币",
    "dateList": [
      "一月 31,2019",
      "星期四,一月,31,2019",
      "31 一月 2019",
      "31-1月-19",
      "1月.31,19",
      "一月 19",
      "1月-19",
      "1月",
      "1/31/2019 10:20:30 上午",
      "1/31/2019 10:20 上午",
      "31/1/2019 10:20:30 上午",
      "31/1/2019 10:20 上午",
      "10:20 上午",
      "10:20:30 上午"
    ],
    "typeList": {
      "string": "字符",
      "number": "数字",
      "dateTime": "日期时间",
      "duration": "持续时间",
      "currency": "货币",
      "boolean": "布尔值",
      "list": "列表",
      "color": "颜色",
      "percentage": "百分比",
      "scientific": "科学计数法"
    },
    "stringList": {
      "normal": "正常",
      "uppercase": "大写",
      "lowercase": "小写"
    }
  },
  "en": {
    "title": "Define Fields",
    "domaintitle": "Define Shape Data",
    "confirm": "OK",
    "cancel": "Cancel",
    "property": "property",
    "name": "Name",
    "type": "Type",
    "format": "Format",
    "value": "Value",
    "preview": "Preview",
    "description": "Description",
    "data": "Properties",
    "addItem": "Add Item",
    "delItem": "Remove Item",
    "decimal": "Decimal Places",
    "separator": "Use 1000 Separator",
    "unit-currency": "Unit/Currency",
    "dateList": [
      "January 31, 2019",
      "Thursday, January, 31, 2019",
      "31 January 2019",
      "31-January-19",
      "Jan.31,19",
      "January 19",
      "January-19",
      "January",
      "1/31/2019 10:20:30 Morning",
      "1/31/2019 10:20 Morning",
      "31/1/2019 10:20:30 Morning",
      "31/1/2019 10:20 Morning",
      "10:20 Moring",
      "10:20:30 Moring"
    ],
    "typeList": {
      "string": "Character",
      "number": "Number",
      "dateTime": "Date Time",
      "duration": "Duration",
      "currency": "Currency",
      "boolean": "Boolean Value",
      "list": "List",
      "color": "Color",
      "percentage": "Percentage",
      "scientific": "Scientific Notation"
    },
    "stringList": {
      "normal": "Normal",
      "uppercase": "Uppercase",
      "lowercase": "Lowercase"
    }
  },
  "fr": {
    "title": "Définir les champs",
    "domaintitle": "Régler les données de forme",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "property": "Propriété",
    "name": "Nom",
    "type": "Type",
    "format": "Format",
    "value": "Valeur",
    "preview": "Aperçu",
    "description": "Description",
    "data": "Données",
    "addItem": "Nouveau",
    "delItem": "Supprimer",
    "decimal": "Décimales",
    "separator": "Utiliser le Séparateur de Milliers",
    "unit-currency": "Unité / Devise",
    "dateList": [
      "31 janvier 2019",
      "Jeudi 31 janvier 2019",
      "31 janvier 2019",
      "31-janvier-19",
      "janvier.31,19",
      "19 janvier",
      "janvier-19",
      "janvier",
      "1/31/2019 10:20:30 matin",
      "1/31/2019 10:20 matin",
      "31/1/2019 10:20:30 matin",
      "31/1/2019 10:20 matin",
      "10:20 matin",
      "10:20:30 matin"
    ],
    "typeList": {
      "string": "Personnage",
      "number": "nombre",
      "dateTime": "Date Heure",
      "duration": "Durée",
      "currency": "Devise",
      "boolean": "Valeur Booléenne",
      "list": "List",
      "color": "Couleur",
      "percentage": "Pourcentage",
      "scientific": "Notation Scientifique"
    },
    "stringList": {
      "normal": "Normal",
      "uppercase": "majuscule",
      "lowercase": "minuscule"
    }
  },
  "de": {
    "title": "Felder definieren",
    "domaintitle": "Benutzerdefinierte Form-Daten",
    "confirm": "Sichern ",
    "cancel": "Abbrechen",
    "property": "Eigenschaft",
    "name": "Name",
    "type": "Typ",
    "format": "Format",
    "value": "Wert",
    "preview": "Vorschau",
    "description": "Deskription",
    "data": "Daten",
    "addItem": "Neu einfügen",
    "delItem": "Löschen",
    "decimal": "Dezimalstellen",
    "separator": "Tausendertrennzeichen",
    "unit-currency": "Einheit/Währungsmittel",
    "dateList": [
      "31.Januar,2019",
      "Dienstag,31.Januar,2019",
      "31.Januar,2019",
      "31-Jan-19",
      "Jan.31,19",
      "Jan.19",
      "Jan-19",
      "Januar",
      "1/31/2019 10:20:30 Vormittag",
      "1/31/2019 10:20 Nachmittag",
      "31/1/2019 10:20:30 Vormittag",
      "31/1/2019 10:20 Vormittag",
      "10:20 Vormittag",
      "10:20:30 Vormittag"
    ],
    "typeList": {
      "string": "Zeichen",
      "number": "Zahlen",
      "dateTime": "Datum Urzeit",
      "duration": "Dauerzeit",
      "currency": "Währungsmittel",
      "boolean": "Boolean ",
      "list": "Liste",
      "color": "Farbe",
      "percentage": "Prozent",
      "scientific": "Wissenschaftlich"
    },
    "stringList": {
      "normal": "Normal",
      "uppercase": "Großschreiben",
      "lowercase": "Kleinschreiben"
    }
  },
  "jp": {
    "confirm": "OK",
    "cancel": "キャンセル",
    "title": "フィールドの定義",
    "domaintitle": "図形データの定義",
    "name": "名称",
    "type": "タイプ",
    "format": "書式",
    "value": "値",
    "description": "説明",
    "data": "データ",
    "addItem": "新規作成",
    "delItem": "削除",
    "decimal": "小数位",
    "separator": "桁区切り記号を使用",
    "unit-currency": "通貨単位",
    "dateList": [
      "一月 31,2019",
      "木曜日,一月,31,2019",
      "31 一月 2019",
      "31-1月-19",
      "1月.31,19",
      "一月 19",
      "1月-19",
      "1月",
      "1/31/2019 10:20:30 午前",
      "1/31/2019 10:20 午前",
      "31/1/2019 10:20:30 午前",
      "31/1/2019 10:20 午前",
      "10:20 午前",
      "10:20:30 午前"
    ],
    "typeList": {
      "string": "文字",
      "number": "数字",
      "dateTime": "日付時刻",
      "duration": "所要時間",
      "currency": "通貨",
      "boolean": "ブール値",
      "list": "リスト",
      "color": "色",
      "percentage": "百分率",
      "scientific": "科学的表記法"
    },
    "stringList": {
      "normal": "一般",
      "uppercase": "大文字",
      "lowercase": "小文字"
    },
    "property": "属性",
    "preview": "プレビュー"
  },
  "es": {
    "title": "Definir campos",
    "domaintitle": "Definir Datos de Forma",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "property": "propiedad",
    "name": "Nombre",
    "type": "Tipo",
    "format": "Formato",
    "value": "Valor",
    "preview": "Previsión",
    "description": "Descripción",
    "data": "Propiedade",
    "addItem": "Agregar artículo",
    "delItem": "Quitar el artículo",
    "decimal": "Decimales",
    "separator": "Usar el separador 1000",
    "unit-currency": "Unidad/Moneda",
    "dateList": [
      "31 de enero de 2019",
      "Jueves, 31 de enero de 2019 ",
      "31 Enero 19",
      "31-Enero-19",
      "31.Enero,19",
      "Enero 19",
      "Enero-19",
      "Enero ",
      "1/31/2019 10:20:30 de la mañana",
      "1/31/2019 10:20 de la mañana",
      "31/1/2019 10:20:30 de la mañana",
      "31/1/2019 10:20 de la mañana",
      "10:20 de la mañana",
      "10:20:30 de la mañana"
    ],
    "typeList": {
      "string": "Carácter",
      "number": "Número",
      "dateTime": "Fecha y hora",
      "duration": "Duración",
      "currency": "Moneda",
      "boolean": "Valor booleano",
      "list": "Lista",
      "color": "Color",
      "percentage": "Porcentaje",
      "scientific": "Notación científica"
    },
    "stringList": {
      "normal": "Normal",
      "uppercase": "Mayúsculas",
      "lowercase": "En minúsculas"
    }
  },
  "pt": {
    "title": "Definir campos",
    "domaintitle": "Definir Forma de Dados",
    "confirm": "OK",
    "cancel": "Cancelar",
    "property": "propriedade",
    "name": "Nome",
    "type": "Tipo",
    "format": "Formato",
    "value": "Valor",
    "preview": "Previsualização",
    "description": "Descrição",
    "data": "Propriedades",
    "addItem": "Adicionar Item",
    "delItem": "Remover Item",
    "decimal": "Casas Decimais",
    "separator": "Usar Separador 1000",
    "unit-currency": "Unidade/Moeda",
    "dateList": [
      "31 de Janeiro, 2019",
      "Quinta-feira, 31, Janeiro, 2019",
      "31 de Janeiro 2019",
      "31-Janeiro-19",
      "31Jan.,19",
      "Janeiro de 19",
      "Janeiro-19",
      "Janeiro",
      "1/31/2019 10:20:30 Manhã",
      "1/31/2019 10:20 Manhã",
      "31/1/2019 10:20:30 Manhã",
      "31/1/2019 10:20 Manhã",
      "10:20 Manhã",
      "10:20:30 Manhã"
    ],
    "typeList": {
      "string": "Caractere",
      "number": "Número",
      "dateTime": "Data Hora",
      "duration": "Duração",
      "currency": "Moeda",
      "boolean": "Valor Booleano",
      "list": "Lista",
      "color": "Cor",
      "percentage": "Percentagem",
      "scientific": "Notação Científica"
    },
    "stringList": {
      "normal": "Normal",
      "uppercase": "Maiúsculas",
      "lowercase": "Minúsculas"
    }
  },
  "it": {
    "title": "Definisci campi",
    "domaintitle": "Definisci Dati Forma",
    "confirm": "OK",
    "cancel": "Annulla",
    "property": "Proprietà",
    "name": "Nome",
    "type": "Tipo",
    "format": "Formato",
    "value": "Valore",
    "preview": "Anteprima",
    "description": "Descrizione",
    "data": "Proprietà",
    "addItem": "Aggiungi Voce",
    "delItem": "Rimuovi Voce",
    "decimal": "Posizioni Decimali",
    "separator": "Usa Separatore Migliaia",
    "unit-currency": "Unità/Valuta",
    "dateList": [
      "Gennaio 31, 2019",
      "Giovedì, Gennaio, 31, 2019",
      "31 Gennaio 2019",
      "31-Gennaio-19",
      "Gen.31,19",
      "Gennaio 19",
      "Gennaio-19",
      "Gennaio",
      "1/31/2019 10:20:30 di Mattina",
      "1/31/2019 10:20 di Mattina",
      "31/1/2019 10:20:30 di Mattina",
      "31/1/2019 10:20 di Mattina",
      "10:20 di Mattina",
      "10:20:30 di Mattina"
    ],
    "typeList": {
      "string": "Carattere",
      "number": "Numero",
      "dateTime": "Data e Ora",
      "duration": "Durata",
      "currency": "Valuta",
      "boolean": "Valore Boolean",
      "list": "Elenco",
      "color": "Colore",
      "percentage": "Percentuale",
      "scientific": "Notazione Scientifica"
    },
    "stringList": {
      "normal": "Normale",
      "uppercase": "Maiuscolo",
      "lowercase": "Minuscolo"
    }
  },
  "tw": {
    "title": "定義域",
    "domaintitle": "定義形狀數據",
    "confirm": "確定",
    "cancel": "取消",
    "property": "屬性",
    "name": "名稱",
    "type": "類型",
    "format": "格式",
    "value": "值",
    "preview": "預覽",
    "description": "說明",
    "data": "數據",
    "addItem": "新建",
    "delItem": "刪除",
    "decimal": "小數位",
    "separator": "使用千位分隔符",
    "unit-currency": "單位/貨幣",
    "dateList": [
      "一月 31,2019",
      "星期四,一月,31,2019",
      "31 一月 2019",
      "31-1月-19",
      "1月.31,19",
      "一月 19",
      "1月-19",
      "1月",
      "1/31/2019 10:20:30 上午",
      "1/31/2019 10:20 上午",
      "31/1/2019 10:20:30 上午",
      "31/1/2019 10:20 上午",
      "10:20 上午",
      "10:20:30 上午"
    ],
    "typeList": {
      "string": "字符",
      "number": "數字",
      "dateTime": "日期時間",
      "duration": "持續時間",
      "currency": "貨幣",
      "boolean": "布爾值",
      "list": "列表",
      "color": "顏色",
      "percentage": "百分比",
      "scientific": "科學計數法"
    },
    "stringList": {
      "normal": "正常",
      "uppercase": "大寫",
      "lowercase": "小寫"
    }
  },
  "kr": {
    "title": "필드 정의",
    "domaintitle": "셰이프 데이터 정의",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "property": "속성",
    "name": "이름",
    "type": "유형",
    "format": "양식",
    "value": "값",
    "preview": "미리 보기",
    "description": "설명",
    "data": "데이터",
    "addItem": "새로 만들기",
    "delItem": "삭제",
    "decimal": "소수 자리",
    "separator": "천 단위 구분자 사용",
    "unit-currency": "단위/ 화폐",
    "dateList": [
      "1월 31,2019",
      "목요일, 1월, 31, 2019",
      "31 1월 2019",
      "31-1월-19",
      "1월.31,19",
      "1월 19",
      "1월-19",
      "1월",
      "1/31/2019 10:20:30 오전",
      "1/31/2019 10:20 오전",
      "31/1/2019 10:20:30 오전",
      "31/1/2019 10:20 오전",
      "10:20 오전",
      "10:20:30 오전"
    ],
    "typeList": {
      "string": "문자",
      "number": "숫자",
      "dateTime": "날짜 시간",
      "duration": "지속시간",
      "currency": "화폐",
      "boolean": "부울 값",
      "list": "목록",
      "color": "색깔",
      "percentage": "퍼센트",
      "scientific": "과학 계수법"
    },
    "stringList": {
      "normal": "정상",
      "uppercase": "대문자",
      "lowercase": "소문자"
    }
  }
}
</i18n>
